import { render, staticRenderFns } from "./ProductsInStockLocations.vue?vue&type=template&id=0c60a470&scoped=true"
import script from "./ProductsInStockLocations.vue?vue&type=script&lang=js"
export * from "./ProductsInStockLocations.vue?vue&type=script&lang=js"
import style0 from "./ProductsInStockLocations.vue?vue&type=style&index=0&id=0c60a470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c60a470",
  null
  
)

export default component.exports